import Api from "@/repository/ApiBase";
import {CreateKanbanEntry, CreatePost} from "@/repository/messagehub.dtos";
import {AxiosResponse} from "axios";


export class KanbanApi extends Api {
    async getKanbanEntries(): Promise<AxiosResponse>{
        let result: AxiosResponse = await this.Client.get('/kanban');
        return result
    }

    async createKanbanEntry(entry: CreateKanbanEntry): Promise<AxiosResponse>{
        const json = JSON.stringify(entry);
        let result: AxiosResponse = await this.Client.post('/kanban', json);
        return result
    }
}
